export default __webpack_public_path__ + "static/media/sad.b9a10c8e.png";